/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiErrorResponse {
  error: Error
}

export interface Error {
  /** @format int32 */
  code: number
  /** @minLength 1 */
  message: string
  details?: string | null
}

export interface RunWorkflowRequest {
  /** @minLength 1 */
  id: string
  inputModel: any
}

export interface WorkflowResponse {
  id: string
  name?: string | null
  description?: string | null
}

import type { AxiosInstance, AxiosRequestConfig, HeadersDefaults, ResponseType } from 'axios'
import axios from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private secure?: boolean
  private format?: ResponseType

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || 'https://api-dev.collaborate.center/staging/',
    })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method)

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      const propertyContent: any[] = property instanceof Array ? property : [property]

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem))
      }

      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>)
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body)
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type ? { 'Content-Type': type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data)
  }
}

/**
 * @title Workflows service api dev
 * @baseUrl https://api-dev.collaborate.center/staging/
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  tabeebWorkflowMicroservice = {
    /**
     * No description
     *
     * @tags Tabeeb.WorkflowMicroservice
     * @name MapTabeebHealthChecksB10
     * @request GET:/workflow-service/api/health/apim
     */
    mapTabeebHealthChecksB10: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/workflow-service/api/health/apim`,
        method: 'GET',
        ...params,
      }),
  }
  userClaimsEndpoints = {
    /**
     * No description
     *
     * @tags UserClaimsEndpoints
     * @name GetUserClaims
     * @request GET:/workflow-service/api/user-claims
     */
    getUserClaims: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/workflow-service/api/user-claims`,
        method: 'GET',
        ...params,
      }),
  }
  workflows = {
    /**
     * No description
     *
     * @tags Workflows
     * @name GetAllAsync
     * @request GET:/workflow-service/api/Workflows
     * @secure
     */
    getAllAsync: (params: RequestParams = {}) =>
      this.http.request<WorkflowResponse[], any>({
        path: `/workflow-service/api/Workflows`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Workflows
     * @name GetByTenantIdAsync
     * @request GET:/workflow-service/api/Workflows/tenant
     * @secure
     */
    getByTenantIdAsync: (params: RequestParams = {}) =>
      this.http.request<WorkflowResponse[], ApiErrorResponse>({
        path: `/workflow-service/api/Workflows/tenant`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Workflows
     * @name RunAsync
     * @request POST:/workflow-service/api/Workflows/run
     * @secure
     */
    runAsync: (data: RunWorkflowRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/workflow-service/api/Workflows/run`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Workflows
     * @name AddTenantWorkflowAsync
     * @request POST:/workflow-service/api/Workflows/{workflowId}/tenant
     * @secure
     */
    addTenantWorkflowAsync: (workflowId: string, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/workflow-service/api/Workflows/${workflowId}/tenant`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Workflows
     * @name RemoveTenantWorkflowAsync
     * @request DELETE:/workflow-service/api/Workflows/{workflowId}/tenant
     * @secure
     */
    removeTenantWorkflowAsync: (workflowId: string, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/workflow-service/api/Workflows/${workflowId}/tenant`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
}
